// src/parts/Home.jsx

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/effect-fade";
import "swiper/css/effect-cube";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import vid from "./../header/og.mp4";
import "aos/dist/aos.css";

const Home = () => {
  return (
    <section
      id="course"
      className="max-w-7xl mx-auto h-[38rem] px-0 sm:px-0 lg:px-0"
    >
      {/* Flex container for the two columns */}
      <div className="flex flex-col lg:flex-row">
        {/* First Column: Text Content */}
        <div className="relative w-full">
          {/* Swiper as the background */}
          <div className="absolute inset-0 z-0">
            <Swiper
              modules={[Pagination, Autoplay, EffectFade]}
              spaceBetween={50}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              speed={1500}
              loop={true}
              effect="fade"
            >
              <SwiperSlide>
                <video
                  src={vid}
                  alt="Slide 4"
                  className="w-full object-cover"
                  style={{ height: "35rem" }}
                  autoPlay
                  loop
                  muted
                />
              </SwiperSlide>
            </Swiper>
          </div>

          {/* Foreground Text Content */}
          <div className="relative z-10 flex flex-col lg:flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-80 sm:w-1/2 sm:ml-24">
            {/* First Column: Text Content */}
            <div className="w-full lg:pr-8 col1 text-white">
              {/* Text Swiper */}
              <h4
                data-aos="fade-up"
                className="text-3xl text-gray-200 font-bold mb-4"
              >
                <span style={{ color: "#3A636C" }}>Welcome To</span> <br />
                Grand Shop Rwanda
              </h4>
              <Swiper
                modules={[Autoplay, EffectFade]}
                spaceBetween={50}
                slidesPerView={1}
                autoplay={{ delay: 3000 }}
                speed={1500}
                loop={true}
              >
                <SwiperSlide>
                  <h2 data-aos="fade-up" className="text-white font-bold">
                    Digital Services
                  </h2>
                  <h3 className="text-white font-gray-200">
                    Effortlessly manage government services, create websites,
                    burn media, and handle online tasks—all under one roof!
                  </h3>
                </SwiperSlide>
                <SwiperSlide>
                  <h2 data-aos="fade-up" className="text-white font-bold">
                    Creative & Print Solutions
                  </h2>
                  <h3 className="text-white font-gray-200">
                    Boost your brand with stunning graphics, high-quality
                    printing, and seamless scanning services.
                  </h3>
                </SwiperSlide>
                <SwiperSlide>
                  <h2 data-aos="fade-up" className="text-white font-bold">
                    Tech & Financial Training
                  </h2>
                  <h3 className="text-white font-gray-200">
                    Enhance your skills with financial insights and tech
                    training, or work comfortably in our cyber café.
                  </h3>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
